import axios from 'axios';
import { urlBase } from '../constants/defaultValues';
import { withRetry } from '../helpers/cartAdd';





const baseUrl = urlBase;


//Traer todos los productos del carrito 
export const allProductsCart = (token) => 
    axios.get(`${baseUrl}/cart`, {
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });

//Agregar productos al carrito
// Con reintentos si la API falla de forma pasajera (sin red, 429 o 5xx): un fallo así ya no se pierde como
// "No pudimos agregar el producto". Repetir no duplica el producto.
export const addProductsCart = (id, quantity, token, variant, choice1, choice2) =>
    withRetry(() => axios.post(`${baseUrl}/cart/add` , {
            id: id,
            quantity: quantity,
            variant: variant || '',
            choice_1: choice1 || '',
            choice_2: choice2 || '',
        },{
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    }));

//Update quantity
export const updateQuantityCart = (qty, id, token) => 
    axios.put(`${baseUrl}/cart/update`, {
        
        key: id,
        quantity: qty
    },{

        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })

//Eliminar item del carrito de compra
export const deleteItemCart = (key, token) => 
    axios.delete(`${baseUrl}/cart/remove`, {
      data:{  
        key: key
    },
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })